import { useContext, useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';

import { META_CATALOG, SOCIAL_PLATFORMS } from 'constants/pixels';
import { ContextWrapper } from 'contexts/wrapper.context';
import { userHasChatsAccess } from 'utils/chats';
import { sendSegment } from 'utils/segment';

import Container from 'components/Container/Container';
import Header from 'components/Header/Header';
import SectionCard from './components/SectionCard/SectionCard';
import ConversationalCommerce from './components/ConversationalCommerce/ConversationalCommerce';

import './Pixels.less';

const Pixels = ({ intl }) => {
  const { businessInfo, setBusinessInfo } = useContext(ContextWrapper);
  const [integratedPixels, setIntegratedPixels] = useState([]);

  const handleIntegratedPixels = () => {
    const {
      featuresConfigurations: {
        plugins: { pixels }
      }
    } = businessInfo;
    setIntegratedPixels(pixels);
  };

  useEffect(() => {
    sendSegment('OPENED_APPSTORE_TAB');
    if (businessInfo?.featuresConfigurations?.plugins?.pixels) {
      handleIntegratedPixels();
    }
  }, [businessInfo]);

  return (
    <Container
      className="br-pixels__container"
      title={intl.formatMessage({ id: 'pixels.header.title' })}
      subtitle={intl.formatMessage({ id: 'pixels.header.subtitle' })}
      header={
        <Header
          title={intl.formatMessage({ id: 'pixels.header.title' })}
          subTitle={intl.formatMessage({ id: 'pixels.header.subtitle' })}
        />
      }
      content={
        <div className="br-app-and-container">
          <div className="br-pixels__content-container">
            <div className="br-pixels__header-container">
              <span className="br-pixels__title display-sm">
                {intl.formatMessage({ id: 'pixels.page.title' })}
              </span>
              <span className="br-pixels__subtitle ">
                {intl.formatMessage({
                  id: 'pixels.page.sub_title'
                })}
              </span>
            </div>
            <div className="br-pixels__sections">
              {SOCIAL_PLATFORMS.map((data) => (
                <SectionCard
                  key={data.apiKey}
                  {...data}
                  isActivated={integratedPixels?.[data.objKey]?.[data.apiKey]}
                  setBusinessInfo={setBusinessInfo}
                  businessInfo={businessInfo}
                />
              ))}
            </div>
          </div>

          <div className="br-meta-catalog-section">
            <div className="br-pixels__header-container">
              <span className="display-sm">
                {intl.formatMessage({
                  id: 'pixels.meta_catalog.header'
                })}
              </span>
              <span className="br-pixels__subtitle ">
                {intl.formatMessage({
                  id: 'pixels.meta_catalog.header_description'
                })}
              </span>
            </div>

            <SectionCard
              key={META_CATALOG.apiKey}
              {...META_CATALOG}
              setBusinessInfo={setBusinessInfo}
              businessInfo={businessInfo}
            />
          </div>

          {userHasChatsAccess(businessInfo) && (
            <div className="br-pixels__content-container">
              <div className="br-pixels__header-container">
                <span className="br-pixels__title display-sm">
                  {intl.formatMessage({
                    id: 'chats_plugins.plugins_page.conversational_commerce'
                  })}
                </span>
                <span className="br-pixels__subtitle ">
                  {intl.formatMessage({
                    id: 'chats_plugins.plugins_page.speed_up_your_sales'
                  })}
                </span>
              </div>

              <div className="br-pixels__sections">
                <div className="br-pixels__sections">
                  <ConversationalCommerce />
                </div>
              </div>
            </div>
          )}
        </div>
      }
    />
  );
};

export default injectIntl(Pixels);
